<div class="notebook-details-container">
   <button class="desp-button" (click)="goHomepage()">Go back to Quantum Emulators</button>
   <h2 class="notebook-title">{{ notebook?.name }}</h2>
   <div class="details-columns">
      <!-- General info -->
      <div class="column">
         <h3 class="section-title">General information</h3>
         <div class="detail-row">
            <span class="label">Quantum Emulator name</span>
            <span class="value">{{ notebook?.name }}</span>
         </div>
         <div class="detail-row">
            <span class="label">Environment</span>
            <span class="value">{{ notebook?.environment}} - {{ notebook?.version }}</span>
         </div>
         <div class="detail-row">
            <span class="label">Privacy</span>
            <span class="value">{{ notebook?.privacy }}</span>
         </div>
      </div>
      <!-- Lifecycle -->
      <div class="column">
         <h3 class="section-title">Lifecycle</h3>
         <!-- Safer: wrap the entire block to avoid typing issues -->
         <ng-container *ngIf="notebook">
            <div class="detail-row">
               <span class="label">Status</span>
               <div class="status-line">
                  <span class="value">{{ notebook.status }}</span>
                  <app-notebook-actions-menu
                  [notebook]="notebook"
                  (start)="onStartNotebook($event)"
                  (stop)="onStopNotebook($event)"
                  (delete)="deleteNotebook($event)"
                  [showDetails]="false">
                  </app-notebook-actions-menu>
               </div>
            </div>
         </ng-container>
         <div class="detail-row">
            <span class="label">Runtime</span>
            <span class="value">{{ notebook?.runtime }}</span>
         </div>
         <div class="detail-row">
            <span class="label">Creation date</span>
            <span class="value">{{ notebook?.creationDate }}</span>
         </div>
         <div class="detail-row" >
            <span class="label">Timeline</span>
            <div *ngFor="let item of notebook?.timeline">
               <span class="value">{{ item.label }}: </span>
               <span class="value">{{ item.value }}</span>
            </div>
         </div>
      </div>
      <!-- Resources -->
      <div class="column">
         <h3 class="section-title">Resources</h3>
         <div class="detail-row">
            <span class="label">Resources</span>
            <span class="value">{{ notebook?.cpu }}x {{ notebook?.flavor }}</span>
            <span class="value">{{ notebook?.cpu }}x {{ notebook?.cpuBrandModel }}</span>
         </div>
         <div class="detail-row">
            <span class="label">Other resources</span>
            <div class="detail-subrow">
               <span class="value">CPU: {{ notebook?.cpu }} vCore</span>
            </div>
            <div class="detail-subrow">
               <span class="value">RAM: {{ notebook?.ram }} GiB</span>
            </div>
            <div class="detail-subrow">
               <span class="value">Public network: {{ notebook?.publicNetwork }}</span>
            </div>
         </div>
         <div class="detail-row">
            <span class="label">Storage</span>
            <div class="detail-subrow">
               <span class="value">Temporarily local storage size: {{ notebook?.storage }} GiB SSD </span>
            </div>
            <div class="detail-subrow" *ngIf="notebook?.workspace?.storageFree">
               <span class="value">Workspace: {{ notebook?.workspace?.storageFree | convertBytesToGiB }} GiB SSD included</span>
            </div>
         </div>
      </div>
   </div>
</div>